/**
 * @generated SignedSource<<17b0e5f32b083cbb9dc9566f4c01b8f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetMcpOauthMethodOverrideInput = {
  id: any;
  method?: string | null | undefined;
};
export type McpOauthAdvancedSettingsSetOverrideMutation$variables = {
  input: SetMcpOauthMethodOverrideInput;
};
export type McpOauthAdvancedSettingsSetOverrideMutation$data = {
  readonly setMcpOauthMethodOverride: {
    readonly error: string | null | undefined;
    readonly server: {
      readonly id: any;
    } | null | undefined;
  };
};
export type McpOauthAdvancedSettingsSetOverrideMutation = {
  response: McpOauthAdvancedSettingsSetOverrideMutation$data;
  variables: McpOauthAdvancedSettingsSetOverrideMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "setMcpOauthMethodOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpOauthAdvancedSettingsSetOverrideMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpOauthAdvancedSettingsSetOverrideMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28e73785fc2122a071ceefd6bd491598",
    "id": null,
    "metadata": {},
    "name": "McpOauthAdvancedSettingsSetOverrideMutation",
    "operationKind": "mutation",
    "text": "mutation McpOauthAdvancedSettingsSetOverrideMutation(\n  $input: SetMcpOauthMethodOverrideInput!\n) {\n  setMcpOauthMethodOverride(input: $input) {\n    server {\n      id\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "493e3218ef14c1d7781056179101ce02";

export default node;
